import { css } from 'styled-components';
import {
  WithFontHeadline,
  WithSiteLayoutPadding,
  WithSiteLayoutWidth,
} from 'styles/commonCss';
import { mqLargeMin } from 'styled/tools/media-queries';

export const Layout = css`
  html[page-type='auth'] {
    .site-content {
      min-height: calc(100vh - 150px);
    }
  }

  html,
  body {
    display: block;
    width: 100%;
    font-family: var(--flag-font-family);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: var(--flag-font-family);
  }

  .site-content {
    overflow: hidden;
    display: block;
    width: 100%;
    padding-top: var(--flag-site-content-padding-top);
  }

  .page-how-vs01-works {
    scroll-behavior: smooth;
    .site-content {
      overflow: visible;
    }
  }

  .site-content > .container {
    ${WithSiteLayoutWidth}
    ${WithSiteLayoutPadding}
  padding-top: 100px;
    margin: 0 auto;
    display: block;
  }

  .site-content > .container > .title {
    ${WithFontHeadline}
  }

  .site-content > .container > .content {
    padding-bottom: var(--spacing-48);

    > .content-wrapper {
      @media ${mqLargeMin} {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .page-404 {
    .site-content {
      padding-top: 0;
    }
  }

  .with-scrolled .nav-sticky {
    transform: translateY(0);
    z-index: 13;
  }
`;
